{
  "TargetreportformatLabel": "Zielberichtsformat:",
  "TargetreportformatPdfOptionLabel": "PDF-Dokument",
  "TargetreportformatRtfOptionLabel": "RTF-Dokument",
  "TargetreportformatCsvOptionLabel": "CSV-Export",
  "UselanguageLabel": "Sprache verwenden:",
  "UselanguageEnusOptionLabel": "Englisch (USA)",
  "UselanguageEngbOptionLabel": "Englisches Vereinigtes Königreich)",
  "PapersizeLabel": "Papier größe:",
  "PapersizeA4OptionLabel": "A4 (210 mm x 297 mm)",
  "PapersizeLegalOptionLabel": "Legal (8½\" x 14\")",
  "PapersizeLetterOptionLabel": "Buchstabe (8½\" x 11\")",
  "Format_SectionHeader": "Format",
  "NAME": "Format",
  "TargetreportformatXlsOptionLabel": "XLS-Export"
}